// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TP1sH","type":"styles_type__19sYe","choices":"styles_choices__3BMfi"};